import { Injectable } from '@angular/core';

const LOCKED_KEY = 'los_screen_locked';
const RETURN_URL_KEY = 'los_screen_lock_return_url';

@Injectable({ providedIn: 'root' })
export class ScreenLockService {
  lock(returnUrl: string): void {
    sessionStorage.setItem(LOCKED_KEY, '1');
    sessionStorage.setItem(RETURN_URL_KEY, returnUrl || '/dashboard');
  }

  unlock(): void {
    sessionStorage.removeItem(LOCKED_KEY);
    sessionStorage.removeItem(RETURN_URL_KEY);
  }

  clear(): void {
    this.unlock();
  }

  isLocked(): boolean {
    return sessionStorage.getItem(LOCKED_KEY) === '1';
  }

  returnUrl(): string {
    return sessionStorage.getItem(RETURN_URL_KEY) ?? '/dashboard';
  }
}
